import clsx from 'clsx'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { CartPaymentTableProps } from './type'

export const CartPaymentTable = ({
  salonPrice,
  purchasePrice,
}: CartPaymentTableProps) => {
  const { t } = useTranslation()

  const salonPriceRows = useMemo(
    () => [
      {
        title: t('order.item.currentOrder'),
        value: `${salonPrice.thisOrder.cost.toLocaleString()} ${t(
          'common.label.yen'
        )}`,
        isVisible: true,
        isBold: false,
      },
      {
        title: t('cart.payment.total'),
        value: `${salonPrice.totalOrder.cost.toLocaleString()} ${t(
          'common.label.yen'
        )}`,
        isVisible: true,
        isBold: true,
      },
      {
        title: t('cart.payment.untilFreeShipping'),
        value: `${(salonPrice.untilFreeShippingCost ?? 0).toLocaleString()} ${t(
          'common.label.yen'
        )}`,
        isVisible: true, //!!untilFreeShippingCost && untilFreeShippingCost > 0,
      },
    ],
    [salonPrice, t]
  )

  const purchasePriceRows = useMemo(
    () =>
      purchasePrice
        ? [
            {
              title: t('order.item.currentOrder'),
              value: `${purchasePrice.thisOrder.cost.toLocaleString()} ${t(
                'common.label.yen'
              )}`,
              isVisible: true,
              isBold: false,
            },
            {
              title: t('cart.payment.total'),
              value: `${purchasePrice.totalOrder.cost.toLocaleString()} ${t(
                'common.label.yen'
              )}`,
              isVisible: true,
              isBold: true,
            },
          ]
        : null,
    [purchasePrice, t]
  )

  return (
    <div className={clsx('tw-pb-4')}>
      <table className={clsx('tw-w-full', 'tw-border tw-border-gray-300')}>
        <tr className={clsx('tw-border-b tw-border-gray-300')}>
          <td
            className={clsx(
              'tw-w-20 lg:tw-w-auto',
              'tw-text-xs',
              'tw-p-1',
              'tw-bg-primary-50',
              'tw-border-r tw-border-gray-300'
            )}
          >
            {t('cart.payment.salonPrice')}
          </td>
          <td className={clsx('tw-p-1', 'tw-space-y-1')}>
            {salonPriceRows.map((r, i) => (
              <div
                className={clsx(
                  'tw-flex tw-items-center tw-justify-between',
                  r.isBold ? 'tw-text-sm  tw-font-bold' : 'tw-text-xs'
                )}
                key={`salon-payment-table-row-${i}`}
              >
                <p>{r.title}</p>
                <p>{r.value}</p>
              </div>
            ))}
          </td>
        </tr>
        {purchasePriceRows && (
          <tr>
            <td
              className={clsx(
                'tw-w-20 lg:tw-w-auto',
                'tw-text-xs',
                'tw-p-1',
                'tw-bg-primary-50',
                'tw-border-r tw-border-gray-300'
              )}
            >
              {t('cart.payment.purchasePrice')}
            </td>
            <td className={clsx('tw-p-1', 'tw-space-y-1')}>
              {purchasePriceRows.map((r, i) => (
                <div
                  className={clsx(
                    'tw-flex tw-items-center tw-justify-between',
                    r.isBold ? 'tw-text-sm  tw-font-bold' : 'tw-text-xs'
                  )}
                  key={`salon-payment-table-row-${i}`}
                >
                  <p>{r.title}</p>
                  <p>{r.value}</p>
                </div>
              ))}
            </td>
          </tr>
        )}
      </table>
      <p
        className={clsx(
          'tw-ml-auto tw-mt-1',
          'tw-text-xs tw-text-gray-600',
          'tw-text-right'
        )}
      >
        {t('cart.payment.note')}
      </p>
    </div>
  )
}
